'use strict';

const jQuery = require('jquery');

const mediator = require('./../../../core/mediator');
const translator = require('./../../../core/translator');
const container = require('./../../../core/container');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const ContentRepository = require('./../repository/ContentRepository');
const Notifier = require('./../../../services/notifier');
const PopinManager = require('./../../../services/popin');
const Loader = require('./../../../services/loader');
const Menu = require('./../../../services/structure/menu/desktop');
const Rte = require('./../../../services/rte');
const Zone = require('./../../../services/structure/zone');
const Overlay = require('./../../../services/overlay');
const overlayMenu = require('./../../../services/overlay/menu');
const syncPromises = require('./../../../services/syncPromise');
const FlashMessage = require('./../../../services/flashMessage');
const PageRepository = require('./../../../bundles/page/repository/page');

const HEADER_ROLLBACK_COUNT = 'X-Rollback-Count';

let publishing = false;
let popinCancel;

const createRemainingPopover = function(onlyOtherPages) {
    let $publishBtn = jQuery('.btn-publish');

    let publishMessage = onlyOtherPages ? translator.translate('publish_other_pages_question') : translator.translate('publish_all_page_question');
    let configPopin = {
        'modal': false,
        'draggable': false,
        'appendTo': 'body',
        'position': {my: 'left+15 center', at: 'right center', of: $publishBtn},
        'buttons': [
            {
                class: 'popin popin-cancel',
                text: translator.translate('no'),
                click: function() {
                    popin.hide();
                },
            },
            {
                text: translator.translate('yes'),
                click: function() {
                    let $toolBar = jQuery('#cloud-nav-primary');
                    let $searchBtn = $toolBar.find('.icon-search');

                    $searchBtn.parent().addClass('btn-focus');
                    mediator.publish('menu:search-page:click', {'callback': function(data) {
                        let $modifiedOption = data.$container.find('li.filter-status.modified');

                        data.$container.find('.filter-status.modified').addClass('active');
                        data.$container.find('.filter-wrapper').removeClass('d-none');
                        data.$container.find('.filter-status-wrapper').find('button').find('span.filter-status-label').text($modifiedOption.find('a').text());
                        $modifiedOption.addClass('active');
                    }});

                    popin.hide();
                },
            },
        ],
    };

    container.set('prevent-hide-toolbar', true);

    if(container.get('isMobile')) {
        configPopin.classes['ui-dialog'] = 'cloud-dialog publish-pages-popover';
    } else {
        configPopin.classes['ui-dialog'] = 'cloud-dialog cloud-dialog-popover cloud-dialog-popover-side-left';
        configPopin.width = 200;
        configPopin.minHeight = 100;
    }

    let popin = PopinManager.createPopin(configPopin);

    popin.setContent('<p class="text-lowercase">' + publishMessage + '</p>');
    popin.rootElement.parent().append('<span class="arrow"></span>');

    popin.on('close', function() {
        container.set('prevent-hide-toolbar', false);
    });

    popin.display();

    return popin;
};

module.exports.publishAll = function() {
    let dfd = jQuery.Deferred();
    let popin;

    let configPopin = {
        'title': translator.translate('publishing'),
        'minHeight': 50,
        'closeOnEscape': false,
        'onClick': function() {
            popin.hide();
        },
    };
    let $content = jQuery('<p class="publishing-content"></p>');

    Loader.start();

    popin = PopinManager.createPopin(configPopin);

    ContentRepository.getPagesToPublish().done(function(pages) {
        let count = 1;
        let total = pages.length;

        syncPromises(pages, function(page) {
            return new Promise((resolve, reject) => {
                $content.html(`${translator.translate('publishing_of')} "${page.title}" (${count}/${total}) ...`);

                ContentRepository.publish(page.uid).done(function() {
                    count = count + 1;

                    if (count >= total) {
                        popin.hide();
                        dfd.resolve();
                    }

                    resolve();
                }).fail(function() {
                    reject();
                });
            });
        });

        Loader.stop();
    });

    popin.on('open', function(event, ui) {
        jQuery('.ui-dialog-titlebar-close', ui.dialog | ui).hide();
    });

    popin.setContent($content);

    popin.display();

    return dfd.promise();
};

module.exports.onPublish = function() {
    if (publishing) {
        return;
    }

    PageRepository.find(container.get('page.uid')).done((page) => {
        let $btnPublish = jQuery('#cloud-ui .btn.btn-publish');
        let $notifierWrapper = container.get('$notifierWrapper');
        let popin;

        let eventData = {page, prevent: false};

        mediator.publish('before:request-publish', eventData);

        if (eventData.prevent) {
            setTimeout(() => {
                Overlay.hide();
            }, 0);
            return;
        }

        let publishContent = () => {
            mediator.publish('before:publish');

            // Confirm page reload when publish is in progress
            jQuery(window).bind('beforeunload', function() {
                return 'Publish in progress, do you want to refresh the page?';
            });

            publishing = true;

            SaveManager.save().done(function() {
                ContentRepository.publish().done(function(count, remainingPublishCount) {
                    let showNotification = !$notifierWrapper || $notifierWrapper.find('.publish-notif').length === 0;
                    if (count > 0) {
                        if (showNotification) {
                            if (remainingPublishCount > 0) {
                                FlashMessage.addCallback('remain-publish');
                                Notifier.success(translator.translate(`publish_done_${page['is_online'] ? 'online' : 'offline'}`));
                            } else {
                                FlashMessage.add(translator.translate(`publish_done_${page['is_online'] ? 'online' : 'offline'}`), 'success');
                            }

                            jQuery(window).unbind('beforeunload');
                            window.location.reload();
                        }

                        $btnPublish.removeClass('is-drafted');
                    } else {
                        jQuery(window).unbind('beforeunload');
                        if (popin) {
                          popin.hide();
                        }

                        if (showNotification) {
                            Overlay.hide();
                            Notifier.warning(translator.translate('nothing_to_publish'), null, 'publish-notif');
                        }
                        if (remainingPublishCount > 0) {
                            Overlay.hide();
                            FlashMessage.addCallback('remain-publish-only-onther-pages');

                            window.location.reload();
                        }
                    }

                    publishing = false;

                    mediator.publish('after:publish');
                    if (popin) {
                      popin.hide();
                    }
                    overlayMenu.hide();
                }).fail(function() {
                    jQuery(window).unbind('beforeunload');
                    popin.rootElement.find('.popin-content').addClass('text-danger').text(translator.translate('publish_error_message'));
                });
            });
        };

        if (page['is_online']) {
            let configPopin = {
                'title': translator.translate('page_online'),
                'minHeight': 50,
                'buttons': [
                    {
                        class: 'popin popin-cancel',
                        text: translator.translate('cancel'),
                        click: function() {
                            popin.hide();
                        },
                    },
                    {
                        class: 'popin popin-ok',
                        text: translator.translate('ok'),
                        click: function() {
                            publishContent();
                        },
                    },
                ],
            };

            popin = PopinManager.createPopin(configPopin);

            popin.setContent(translator.translate(`publish_online_message`));
            popin.display();
        } else {
            publishContent();
        }
    });
};

module.exports.createRemainingPopover = createRemainingPopover;

module.exports.beforePublish = function() {
    let $currentRte = jQuery('.cloud-rte-enabled');
    let $content = $currentRte;
    let $btnPublish = jQuery('#cloud-ui .btn.btn-publish');
    let currentRteContent;

    if (!$content.hasClass('bb-content')) {
        $content = $content.parents('.bb-content:first');
    }

    Zone.hidePanels();

    if ($currentRte.length > 0) {
        currentRteContent = ContentManager.getContentByNode($content);
        if (null !== currentRteContent) {
            Rte.destroy({'content': currentRteContent, '$element': $currentRte, 'save': false, 'parameter': !!$currentRte.attr('data-parameter-rte')});
        }
    }

    $btnPublish.find('i').addClass('d-none');

    Loader.start($btnPublish);
};

module.exports.afterPublish = function() {
    let $btnPublish = jQuery('#cloud-ui .btn.btn-publish');

    $btnPublish.find('i').removeClass('d-none');
    Loader.stop($btnPublish);

    Menu.unFocus();
};

module.exports.onCancel = function() {
    Menu.unFocus();

    if (!jQuery('#cloud-ui .btn.btn-publish').hasClass('is-drafted')) {
        Notifier.warning(translator.translate('nothing_to_cancel'), null, 'cancel-notif');
        return;
    }

    if (popinCancel) {
        return;
    }

    PageRepository.find(container.get('page.uid')).done((page) => {
        Zone.hidePanels();

        popinCancel = PopinManager.createPopin({
            'title': translator.translate('cancel_publish_title'),
            'minHeight': 50,
            'buttons': [
                {
                    class: 'popin popin-cancel',
                    text: translator.translate('discard'),
                    click: function() {
                        popinCancel.hide();
                        popinCancel = null;
                    },
                },
                {
                    class: 'popin popin-ok',
                    text: translator.translate('submit'),
                    click: function() {
                        let $currentRte = jQuery('.cloud-rte-enabled');
                        let currentRteContent;

                        if ($currentRte.length > 0) {
                            currentRteContent = ContentManager.getContentByNode($currentRte);

                            if (null !== currentRteContent) {
                                Rte.restore({
                                    'content': currentRteContent,
                                    'save': false,
                                });
                            }
                        }

                        ContentRepository.cancel().done(function(data, response) {
                            popinCancel.hide();

                            const rollbackCount = response.getHeader(HEADER_ROLLBACK_COUNT) || response.getHeader(HEADER_ROLLBACK_COUNT.toLowerCase());

                            if (rollbackCount > 0) {
                                FlashMessage.addCallback('canceled-page');
                                window.location.reload();
                            } else {
                                Notifier.warning(translator.translate('nothing_to_cancel'), null, 'cancel-notif');
                            }

                            return data;
                        });
                    },
                },
            ],
        });

        popinCancel.on('close', function() {
            popinCancel = null;
        });

        popinCancel.setContent(translator.translate(`cancel_publish_message_${page['is_online'] ? 'online' : 'offline'}`));

        popinCancel.display();
    });
};

module.exports.onCanceledPageFlashCallback = function() {
    Notifier.success(translator.translate('page_canceled'));
};
